import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { ThemeProvider } from 'styled-components'
import DWMap from 'components/DWMap'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { getTheme } from '../../theme/config'
import { ReactElement } from 'react'
import GlobeHelper from 'components/GlobeHelper'
import Ai2HtmlImage from 'components/Ai2HtmlImage'
import Ai2HtmlImageTest from 'components/Ai2HtmlImage'
import Illustration from 'components/Illustration'
import Debris from 'components/Debris'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const theme = getTheme(colorMode, tenant)
  const darkSuffix = theme.colorMode === 'dark' ? '-dark' : ''
  const isMobile = window.innerWidth < 768
  const mobileSuffix = isMobile ? '-mobile' : ''

  const modules: { [key: string]: ReactElement } = {
    globe: <GlobeHelper />,
    test: (
      <Ai2HtmlImageTest
        imageSrc={require(`./globe-1${darkSuffix}${mobileSuffix}.png`)}
        imageAlt="Carte représentant l'itinéraire de vol de l'avion disparu."
        imageLegend='Agence australienne de sécurité des transports, ministère des transports de Malaisie'
      />
    ),
    mapA: (
      <Ai2HtmlImage
        imageSrc={require(`./globe-1${darkSuffix}${mobileSuffix}.png`)}
        imageAlt="Carte représentant l'itinéraire de vol de l'avion disparu."
        imageLegend='Agence australienne de sécurité des transports, ministère des transports de Malaisie'
      />
    ),
    mapB: (
      <Ai2HtmlImage
        imageSrc={require(`./globe-2${darkSuffix}${mobileSuffix}.png`)}
        imageAlt='Carte représentant la position calculée de l’avion disparu.'
        imageLegend='Agence australienne de sécurité des transports'
      />
    ),
    mapC: (
      <Ai2HtmlImage
        imageSrc={require(`./globe-3${darkSuffix}${mobileSuffix}.png`)}
        imageAlt='Carte représentant les zones de recherche de l’avion disparu.'
        imageLegend='Agence australienne de sécurité des transports, ministère des transports de Malaisie'
      />
    ),
    illustration: <Illustration imageSrc={require(`./illustration.png`)} />,
    debris: <Debris imageSrc={require(`./debris.png`)} />,
  }

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>{modules[properties.module]}</ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin: 40px 0;
`

const Content = styled.div``

export default MainComponent
